import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from '../../axios/axiosconf';
import { getFormaPagoTexto } from '../../../utils/formasPago';

function VistaPreviaDocumentoSoporte() {
    const { id } = useParams();
    const [documento, setDocumento] = useState(null);
    const [client, setClient] = useState(null);
    const [proveedor, setProveedor] = useState(null);
    const [usuarios, setUsuarios] = useState([]);
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [creador, setCreador] = useState(null); // 🆕 Estado para el usuario que creó el documento
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarDatos();
    }, [id]);

    const getMetodoPagoTexto = (codigo) => getFormaPagoTexto(codigo);

    const cargarDatos = async () => {
        let userdata = JSON.parse(localStorage.getItem('userdata') || '{}');

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        try {
            const [clienteResponse, documentoResponse, proveedoresResponse, usuariosResponse] = await Promise.all([
                axios.get('/get-client?uid=' + userdata.user_id, config),
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`, config),
                axios.get(`/proveedores?uid=${userdata.user_id}`, config),
                axios.get(`/users-by-client?uid=${userdata.user_id}`, config)
            ]);

            setClient(clienteResponse.data);
            setDocumento(documentoResponse.data);
            setUsuarios(usuariosResponse.data);

            const proveedorEncontrado = proveedoresResponse.data.find(p => p.id === documentoResponse.data.proveedor_id);
            setProveedor(proveedorEncontrado);

            // 🆕 Cargar encabezado personalizado del usuario que creó el documento
            if (documentoResponse.data.users_id) {
                try {
                    const encabezadoResponse = await axios.get(`/encabezado-personalizado?uid=${documentoResponse.data.users_id}`, config);
                    if (encabezadoResponse.status === 200 && encabezadoResponse.data && encabezadoResponse.data.estado === 1) {
                        setEncabezadoPersonalizado(encabezadoResponse.data);
                        console.log('Encabezado personalizado cargado:', encabezadoResponse.data);
                    }
                } catch (error) {
                    console.log('No hay encabezado personalizado habilitado:', error);
                    setEncabezadoPersonalizado(null);
                }

                // 🆕 Cargar información del usuario que creó el documento (creador)
                const usuarioEncontrado = usuariosResponse.data.find(u => u.id == documentoResponse.data.users_id);
                if (usuarioEncontrado) {
                    setCreador(usuarioEncontrado);
                    console.log('Creador cargado:', usuarioEncontrado);
                }
            }

        } catch (error) {
            console.error('Error al cargar datos:', error);
            alert('Error al cargar los datos del documento soporte');
        } finally {
            setLoading(false);
        }
    };

    const imprimir = () => {
        window.print();
    };

    if (loading || !documento || !client || !proveedor) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <p className="mt-2">Cargando documento soporte...</p>
                </div>
            </div>
        );
    }

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const obtenerNit = () => {
        if (client.numero_documento) {
            return client.digito_verificacion
                ? `${client.numero_documento}-${client.digito_verificacion}`
                : client.numero_documento;
        }
        return '';
    };

    const obtenerNitProveedor = () => {
        if (proveedor.numero_documento) {
            return proveedor.dv
                ? `${proveedor.numero_documento}-${proveedor.dv}`
                : proveedor.numero_documento;
        }
        return '';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    // 🆕 Función para generar encabezado personalizado HTML (igual que en VistaPreviaFactura)
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return null;
        }

        return (
            <div style={{ marginBottom: '10px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#ffffff' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '30%', padding: '2px', fontSize: '10px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.izquierda }} />
                            <td style={{ width: '40%', padding: '2px', textAlign: 'center', fontSize: '11px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.centro }} />
                            <td style={{ width: '30%', padding: '2px', textAlign: 'right', fontSize: '10px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.derecha }} />
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const nombreUsuario = getNombreUsuario(documento?.users_id);

    return (
        <div className="container-fluid p-0">
            <div className="invoice p-2" id="invoice-content">
                {/* 🆕 Encabezado Personalizado */}
                {generarEncabezadoHTML()}

                {/* 🆕 BANNER: DOCUMENTO SOPORTE */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <div style={{
                            backgroundColor: '#e9ecef',
                            padding: '4px 8px',
                            fontWeight: 'bold',
                            fontSize: '10px',
                            borderRadius: '3px',
                            textAlign: 'center',
                            border: '1px solid #dee2e6'
                        }}>
                            DOCUMENTO SOPORTE N° {documento.prefijo}-{documento.numero}
                        </div>
                    </div>
                </div>

                {/* 🆕 Datos del Documento Soporte */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <table className="table table-bordered w-100 mb-0" style={{ fontSize: '10px' }}>
                            <tbody>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>DOCUMENTO #</td>
                                    <td className="bg-white p-1" style={{ width: '18%' }}>{documento.numero}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>PREFIJO</td>
                                    <td className="bg-white p-1" style={{ width: '18%' }}>{documento.prefijo || 'N/A'}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>FECHA EMISIÓN</td>
                                    <td className="bg-white p-1" style={{ width: '19%' }}>{formatearFecha(documento.fecha_emision)}</td>
                                </tr>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1">FORMA DE PAGO</td>
                                    <td colSpan="3" className="bg-white p-1">{getMetodoPagoTexto(documento.forma_pago)}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1">TIPO PAGO</td>
                                    <td className="bg-white p-1">{documento.tipo_pago === 'pagada' ? 'Pagada' : 'Por Pagar'}</td>
                                </tr>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1">CREADO POR</td>
                                    <td colSpan="5" className="bg-white p-1">
                                        {creador ? creador.name : nombreUsuario}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Datos del Proveedor */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <table className="table table-bordered w-100 mb-0" style={{ fontSize: '10px' }}>
                            <tbody>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>PROVEEDOR</td>
                                    <td className="bg-white p-1" style={{ width: '35%' }}>{proveedor.nombre_proveedor}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>NIT/DOCUMENTO</td>
                                    <td className="bg-white p-1" style={{ width: '35%' }}>{obtenerNitProveedor()}</td>
                                </tr>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1">TELÉFONO</td>
                                    <td className="bg-white p-1">{proveedor.telefono || proveedor.celular || ''}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1">CELULAR</td>
                                    <td className="bg-white p-1">{proveedor.celular || ''}</td>
                                </tr>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1">EMAIL</td>
                                    <td className="bg-white p-1">{proveedor.email || ''}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1">DIRECCIÓN</td>
                                    <td className="bg-white p-1">{proveedor.direccion || ''}</td>
                                </tr>
                                {/* UEDI para documentos soporte electrónicos */}
                                {documento.uedi && (
                                    <tr>
                                        <td className="bg-light font-weight-bold align-middle p-1">UEDI</td>
                                        <td colSpan="3" className="bg-white p-1 text-break" style={{ fontSize: '10px' }}>{documento.uedi}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Tabla de Conceptos */}
                <div className="row m-0">
                    <div className="col-12 p-0 table-responsive">
                        <table className="table table-striped w-100 mb-0" style={{ fontSize: '10px' }}>
                            <thead>
                                <tr>
                                    <th className="p-1">Código</th>
                                    <th className="p-1">Descripción</th>
                                    <th className="p-1">Cantidad</th>
                                    <th className="p-1">Precio Unit.</th>
                                    <th className="p-1">Descuento</th>
                                    <th className="p-1">IVA</th>
                                    <th className="text-right p-1">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documento.detalle?.map((item, index) => {
                                    const lineTotal = item.vrunitario * item.cantidad;
                                    const descuento = lineTotal * (item.descuento / 100);
                                    const baseImponible = lineTotal - descuento;
                                    const iva = baseImponible * (item.iva / 100);
                                    const total = baseImponible + iva;

                                    return (
                                        <tr key={index}>
                                            <td className="p-1">{item.concepto_pago?.codigo}</td>
                                            <td className="p-1">{item.concepto_pago?.nombre}</td>
                                            <td className="p-1">{item.cantidad}</td>
                                            <td className="p-1">${Math.round(parseFloat(item.vrunitario)).toLocaleString('es-CO')}</td>
                                            <td className="p-1">{item.descuento}%</td>
                                            <td className="p-1">{item.iva}%</td>
                                            <td className="text-right p-1">${Math.round(total).toLocaleString('es-CO')}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                    <td className="text-left font-weight-bold pl-2 p-1" style={{ borderTop: '2px solid #dee2e6' }}>Subtotal:</td>
                                    <td className="text-right p-1" style={{ borderTop: '2px solid #dee2e6' }}>${Math.round(parseFloat(documento.valor_bruto)).toLocaleString('es-CO')}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                    <td className="text-left font-weight-bold pl-2 p-1" style={{ borderTop: '1px solid #dee2e6', fontSize: '10px' }}>Total:</td>
                                    <td className="text-right font-weight-bold p-1" style={{ borderTop: '1px solid #dee2e6', fontSize: '10px' }}>${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                {/* Observaciones */}
                {documento.observaciones && (
                    <div className="row m-0 mt-2">
                        <div className="col-12 p-0">
                            <h6 style={{ fontSize: '10px', marginBottom: '2px', fontWeight: 'bold' }}>Observaciones:</h6>
                            <p style={{ fontSize: '10px', marginBottom: '0' }}>{documento.observaciones}</p>
                        </div>
                    </div>
                )}

                {/* Pie de página legal - Solo para documentos soporte electrónicos */}
                {documento.uedi && (
                    <div className="row m-0 mt-3" style={{ borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                        <div className="col-12 p-0">
                            <p style={{ fontSize: '8px', color: '#666', marginBottom: '0', textAlign: 'justify', lineHeight: '1.3' }}>
                                <strong>Nota Legal:</strong> Este documento soporte de adquisiciones efectuadas a sujetos no obligados a facturar ha sido generado y transmitido conforme a lo establecido en el Decreto 2242 de 2015 y la Resolución DIAN 000042 de 2020. 
                                El UEDI (Código Único de Documento Electrónico) garantiza la autenticidad e integridad del documento. 
                                Para verificar la validez de este documento electrónico, puede consultar en el portal de la DIAN utilizando el UEDI proporcionado. 
                                Este documento tiene plena validez legal y probatoria de acuerdo con la normativa colombiana vigente.
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                @media print {
                    .no-print { display: none !important; }
                    body, html, #root {
                        height: auto;
                        margin: 0;
                        padding: 0;
                        background-color: white;
                    }
                    .container-fluid {
                        padding: 0 !important;
                        margin: 0 !important;
                    }
                    .invoice {
                        width: 100% !important;
                        padding: 0 !important;
                        margin: 0 !important;
                    }
                    /* Evitar cortes de página en bloques */
                    .row {
                        page-break-inside: avoid;
                        margin: 0 !important;
                    }
                    table {
                        page-break-inside: auto;
                        width: 100% !important;
                    }
                    tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    td, th {
                        padding: 2px !important;
                    }
                    @page {
                        size: landscape;
                        margin: 5mm; 
                    }
                }
            `}</style>
        </div>
    );
}

export default VistaPreviaDocumentoSoporte;
